import { render, staticRenderFns } from "./stash.vue?vue&type=template&id=5a39964c&"
import script from "./stash.vue?vue&type=script&lang=js&"
export * from "./stash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports